import state from './Order/states'
import mutations from './Order/mutations'
import actions from './Order/actions'
import getters from './Order/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
